(function () {
    'use strict';

    angular.module('swif.ui')
    .controller('SwifWebmailModalController', SwifWebmailModalController);


    function SwifWebmailModalController($scope, $q, swif) {
        console.log('init SwifWebmailModalController');

        var user = swif.user.getAuthenticatedUserData();
        $scope.mode = {write: false};
        $scope.filters = {partner_address: {}};
        $scope.attachment_ids = {};
        swif.data.addFilter($scope.filters.partner_address, 'email', '!=', false);
        swif.data.addFilter($scope.filters.partner_address, 'email', '!=', '');
        const tinymceOptions = {
            height: 300,
            plugins: 'textcolor code',
            language : 'fr_FR',
            menubar: false,
            toolbar: 'formatselect | fontselect | fontsizeselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | forecolor | code | removeformat'
        };

        $scope.createNewMail = function() {
            swif.resources.add(['tinymce']).then(function () {
                $scope.tinymceOptions = tinymceOptions;
                $scope.mode.write = !$scope.mode.write;
                var settings = swif.settings.getContentType($scope.model._type);
                if ($scope.mode.write) {
                    if ($scope.model.swif_id === undefined) {
                        var item_id = $scope.model.id;
                    } else {
                        item_id = $scope.model.swif_id;
                    }
                    $scope.newMail = {
                        body_text: '',
                        body_html: '',
                        subject: '[' + item_id + '] ' + $scope.model.name,
                        model: settings.model,
                        res_id: $scope.model.id,
                        email_from: user.email,
                        date: moment().format('YYYY-MM-DD HH:mm:ss')
                    };
                    if (user.signature) {
                        $scope.newMail.body_html += '<br/><hr/><pre>' + user.signature + '</pre>';
                    }
                }
            });

        };
        var addOriginalMail = function (current) {
            $scope.newMail.references = current.message_id;
            $scope.newMail.body_html += '<blockquote>';
            if (current.email_from) {
                $scope.newMail.body_html +=  '> De: ' + current.email_from + '<br/>\n';
            }
            if (current.email_to) {
                $scope.newMail.body_html +=  '> A: ' + current.email_to + '<br/>\n';
            }
            if (current.email_to) {
                $scope.newMail.body_html +=  '> CC: ' + current.email_to + '<br/>\n';
            }
            if (current.body_text) {
                _.forEach(current.body_text.split('\n'), function (line) {
                    $scope.newMail.body_html +=  line.trim() + '<br/>\n';
                });
            } else if (current.body_html) {
                _.forEach(current.body_html.split('\n'), function (line) {
                    $scope.newMail.body_html +=  '\n';
                    $scope.newMail.body_html +=  '> ' + line.trim();
                });
            }
            $scope.newMail.body_html += '</blockquote>';
        };
        $scope.reply = function () {
            swif.resources.add(['tinymce']).then(function () {
                $scope.tinymceOptions = tinymceOptions;
                var current = $scope.mails.currentItem;
                $scope.mode.write = true;
                $scope.mode.raw = true;
                $scope.newMail.email_to = '';
                $scope.newMail.date = moment.utc().format('YYYY-MM-DD HH:mm:ss');

                $scope.newMail.email_cc = current.email_cc;
                if (current.email_from) {
                    $scope.newMail.email_to = current.email_to;
                }
                $scope.newMail.body_html = '';
                if (user.signature) {
                    $scope.newMail.body_html += '<br/><hr/><pre>' + user.signature + '</pre>';
                }
                addOriginalMail(current);
            });
        };
        $scope.ffw = function () {
            swif.resources.add(['tinymce']).then(function () {
                $scope.tinymceOptions = tinymceOptions;
                $scope.reply();
                $scope.newMail.email_to = '';
                $scope.newMail.email_cc = '';
                $scope.newMail.email_bcc = '';
                $scope.newMail.body_html = '';
                if (user.signature) {
                    $scope.newMail.body_html += '<br/><hr/><pre>' + user.signature + '</pre>';
                }
                addOriginalMail($scope.mails.currentItem);
            });
        };
        var sendMail = function (m) {
            var context;
            if ($scope.model._report) {
                context = {
                    'report_name': $scope.model._report[0]
                };
            }
            var onCreate = function (result) {
                $scope.mode.write = false;
                $scope.mails.callback(null, {
                    action: {id: 'add'},
                    result: result,
                    model: m
                });
                $scope.mails.setCurrent(m);
                return swif.email.send(result.result).then(function () {
                    return result;
                });
            };
            var onSent = function (result) {
                swif.message.addInfo('Mail message sent');
                $scope.mails.updateItem(m);
                return result;
            };
            return swif.email.createMailMessage(m, context)
            .then(onCreate)
            .then(onSent);
        };
        $scope.sendNewMail = function () {
            var promises = [];
            var m = angular.copy($scope.newMail);
            m.state = 'outgoing';
            m.subtype = 'html';
            //put email_to_ids into email_to
            var onEmailAddress = function (data, field) {
                if (!_.isEmpty(m[field])) {
                    m[field] += ',';
                } else {
                    m[field] = '';
                }
                _.forEach(data.records, function (address) {
                    //tout pt <toutpt@gmail.com>, Stéphane DOUDET <sdoudet@atreal.fr>
                    m[field] += address.email + ', ';
                });
            };
            var onEmailToIds = function (data) {
                onEmailAddress(data, 'email_to');
            };
            var onEmailCCIds = function (data) {
                onEmailAddress(data, 'email_cc');
            };
            var onEmailBCCIds = function (data) {
                onEmailAddress(data, 'email_bcc');
            };
            var searchPartnerAddress = function (ids) {
                var filter = {};
                swif.data.addFilter(filter, 'id', 'in', ids);
                filter.fields = ['id', 'complete_name', 'email'];
                return swif.data.searchRead('partner_address', filter);
            };
            var ids = m.email_to_ids;
            if (!_.isEmpty(ids)) {
                promises.push(
                    searchPartnerAddress(ids).then(onEmailToIds)
                );
            }
            ids = m.email_cc_ids;
            if (!_.isEmpty(ids)) {
                promises.push(
                    searchPartnerAddress(ids).then(onEmailCCIds)
                );
            }
            ids = m.email_bcc_ids;
            if (!_.isEmpty(ids)) {
                promises.push(
                    searchPartnerAddress(ids).then(onEmailBCCIds)
                );
            }
            $q.all(promises).then(function () {
                sendMail(m);
            });
        };
        var loadFollowers = function () {
            swif.email.getEmailFilter($scope.model).then(filter => {
                filter.fields = ['email_from', 'email_to', 'email_cc'];
                filter.limit = 0;
                swif.data.searchRead('mail_message', filter).then(function (mails) {
                    var emails = [];
                    var addemail = function (email) {
                        if (email) {
                            email = email.replace(/,/g,'');
                            if (!_.contains(emails, email)) {
                                emails.push(email);
                            }
                        }
                    };
                    _.forEach(mails.records, function (email) {
                        addemail(email.email_from);
                        addemail(email.email_to);
                        addemail(email.email_cc);
                    });
                    $scope.followers = emails;
                });
                /** ONLY WORKS WITH REQUEST
                swif.data.callKw($scope.model._type, 'message_thread_followers', [$scope.model.id])
                .then(function (data) {
                    $scope.followers = data[$scope.model.id];
                });
                */
            });
        };
        var loadAttachments = function () {
            if (!$scope.model._attachments) {
                swif.attachment.getAttachments($scope.model)
                .then(function (ret) {
                    $scope.model._attachments = ret.attachments;
                    $scope.model._attachments_img = swif.attachment.getImages(ret.attachments);
                });
            }
        };
        $scope.$watch('mails.currentItem', function (newV) {
            if (newV) {
                $scope.mode.write = false;
            }
        });
        $scope.$watch('newMail.body_html', function (newV) {
            if (newV && tinyMCE.activeEditor) {
                $scope.newMail.body_text = tinyMCE.activeEditor.getContent({format : 'text'});
            }
        });
        var setAttachmentIdsToMail = function (newMail, attachment_ids) {
            newMail.attachment_ids = [];
            if (attachment_ids) {
                _.forOwn(attachment_ids, function (value, key) {
                    if (value) {
                        newMail.attachment_ids.push(parseInt(key, 10));
                    }
                });
            }
        };
        $scope.$watch('attachment_ids', function (newV) {
            if (!$scope.newMail) {
                return;
            }
            setAttachmentIdsToMail($scope.newMail, newV);
        }, true);

        $scope.$watch('model', function (newV) {
            if (newV) {
                var settings = swif.settings.getContentType(newV._type);
                var printAction = swif.action.getActionById(
                    newV._type, 'primary', 'print', newV
                );
                if (printAction) {
                    $scope.reports = printAction.reports;
                }
                loadFollowers();
                loadAttachments();
                $scope.newMail = {
                    subject: '[' + newV.id + '] ' + newV.name,
                    model: settings.model,
                    res_id: newV.id,
                    email_from: user.email
                };
                if ($scope.attachment_ids) {
                    setAttachmentIdsToMail($scope.newMail, $scope.attachment_ids);
                }
                swif.email.createEmailCollection('webmail', newV)
                .then(function (collection) {
                    $scope.mails = collection;
                    $scope.mails.currentItem = undefined;
                });
            }
        });
    }

})();
